import {
	GetAccessManagementFeaturesParams,
	GetAccessManagementFeaturesResponse,
} from 'domain/usecases';
import {makeGetAccessManagementFeatures} from 'main/factories/usecases';

export async function getAccessManagementFeatures(
	params: GetAccessManagementFeaturesParams,
): Promise<GetAccessManagementFeaturesResponse> {
	return makeGetAccessManagementFeatures().get(params);
}
